var map = {
	"./all-1.mp4": "iZy2",
	"./all-1_PLACEHOLDER.png": "ZShq",
	"./chorus-1.png": "cNli",
	"./chorus-2.jpg": "/Umt",
	"./chorus-3.jpg": "M2Sf",
	"./chorus-4.png": "wLMX",
	"./chorus-5.jpg": "uGVw",
	"./chorus-6.png": "3s09",
	"./chorus-thumbnail.jpg": "wrxd",
	"./covid-19-1.gif": "AvlE",
	"./covid-19-1_PLACEHOLDER.jpg": "ZHEi",
	"./covid-19-2.jpg": "WJ8l",
	"./covid-19-3.jpg": "bvxJ",
	"./covid-19-4.jpg": "qPGg",
	"./covid-19-5.jpg": "SH4d",
	"./covid-19-6.jpg": "oJ+o",
	"./covid-19-thumbnail.jpeg": "xwmr",
	"./dunkin-1.gif": "QFRu",
	"./dunkin-1_PLACEHOLDER.jpg": "r7gq",
	"./eb-1.mp4": "jCsO",
	"./elephant-1.png": "/RRp",
	"./elephant-2.jpg": "baEA",
	"./elephant-3.png": "Q4RJ",
	"./elephant-4.jpg": "nEhg",
	"./elephant-5.gif": "4k6t",
	"./elephant-5_PLACEHOLDER.jpg": "gcTO",
	"./elephant-thumbnail.jpg": "U3In",
	"./fonts/KotoriRose-Bold.otf": "3Mxo",
	"./fonts/KotoriRose-Regular.otf": "kLKT",
	"./fr-1.mp4": "MmEq",
	"./gin-1.jpg": "30zk",
	"./gin-2.jpg": "R+vp",
	"./gin-thumbnail.jpg": "m78T",
	"./gin.mp4": "QBp9",
	"./kitty-ann.gif": "+fEX",
	"./kitty-ann_PLACEHOLDER.jpg": "XcBP",
	"./nyoutritious-1.gif": "cGRO",
	"./nyoutritious-1_PLACEHOLDER.jpg": "C0PU",
	"./nyoutritious-2.jpeg": "JLfO",
	"./nyoutritious-3.png": "Thef",
	"./nyoutritious-4.png": "C8Ru",
	"./nyoutritious-5.png": "xjBx",
	"./nyoutritious-thumbnail.jpeg": "Z9dI",
	"./recipe-collect-1.png": "WeXT",
	"./recipe-collect-2.jpg": "dtdh",
	"./recipe-collect-3.jpeg": "gFZb",
	"./recipe-collect-4.jpeg": "zba+",
	"./recipe-collect-5.jpeg": "n/Av",
	"./recipe-collect-6.jpeg": "ztuk",
	"./recipe-collect-thumbnail.jpeg": "EbAn",
	"./shapes-1.gif": "GNHF",
	"./shapes-1_PLACEHOLDER.jpg": "kzxd",
	"./sigma-1.jpeg": "m7Uo",
	"./sigma-2.jpeg": "x3Nc",
	"./sigma-3.gif": "Nrol",
	"./sigma-3_PLACEHOLDER.jpg": "5TXU",
	"./sigma-4.png": "l+m9",
	"./sigma-5.png": "wbOJ",
	"./sigma-thumbnail.jpeg": "chU8",
	"./wedding-2.png": "G2Dy",
	"./wedding-3.png": "1cOz",
	"./wedding-4.gif": "dqyC",
	"./wedding-4_PLACEHOLDER.jpg": "WU31",
	"./wedding-home-on-macbook.gif": "cbw1",
	"./wedding-home-on-macbook_PLACEHOLDER.jpg": "4mbC",
	"./wedding-web-cover.gif": "xJSa",
	"./wedding-web-cover_PLACEHOLDER.jpg": "kS4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AQqv";